// prompts.<area>.<key>: the suggested questions (services/platform-agent/platformAgentSuggestions.js), sent as typed.
// {{dish}} is a dish on the restaurant's menu, {{amount}} an amount in its currency (both from the picker).
export default {
  title: 'Hoi {{first_name}}, wat heb je nodig voor {{restaurant}}?',
  title_no_name: 'Hoi, wat heb je nodig voor {{restaurant}}?',
  text: 'Ik kan vragen over {{restaurant}} beantwoorden en wijzigingen voor je doorvoeren. Er verandert niets totdat je het goedkeurt.',
  suggestions: 'Suggesties',
  prompts: {
    reports: {
      top_dishes: 'Wat waren de 10 populairste gerechten van vorige maand?',
      sales_vs_last_month: 'Hoe waren de verkopen vergeleken met vorige maand?',
    },
    menu: {
      raise_dish_price: 'Verhoog de prijs van {{dish}} met {{amount}}',
      dish_sold_out: 'Markeer {{dish}} als uitverkocht',
      dishes_without_photo: 'Welke gerechten hebben geen foto?',
    },
    hours: {
      holiday_hours: 'Wijzig onze openingstijden voor 24 december',
    },
    order_settings: {
      minimum_order: 'Verhoog het minimumbedrag voor bestellingen naar {{amount}}',
    },
    marketing: {
      promo_code: 'Maak een promocode van 10 % voor dit weekend',
    },
    my_info: {
      phone_number: 'Werk ons telefoonnummer bij',
    },
  },
};
